import { Component, OnInit, Input, HostListener, AfterViewInit, AfterContentInit, AfterViewChecked, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, NavigationExtras, NavigationStart } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UIHeaderService } from '../services/ui-header.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SingUpService } from '../services/signup.service';
import { ChangeDetectorRef } from '@angular/core';
import { SharedService } from '../services1/shared.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalPopupComponent } from '../layout1/modal-popup/modal-popup.component';
import { ToastrService } from 'ngx-toastr';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { DatePipe } from '@angular/common';
import { SallerBuyerService } from 'src/app/main/dashboard/sallerBuyer.service';
import { LanguageService } from '../services1/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('submenuToggle', [
      state('closed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('open', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      transition('closed <=> open', [
        animate('300ms ease-in-out')
      ]),
    ])
  ]

})

export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dropdownToggle', { static: true }) dropdownToggle!: ElementRef;
  showSubmenu = false;
  showVehicleSubmenu = false;
  Howitworks=false;
  // @ViewChild('dropdownToggle', { static: true }) dropdownToggle!: ElementRef;
  @ViewChild('auctionsMenu', { static: false }) auctionsMenu!: ElementRef;
  showLaneSubmenu = false;
  isScrolled: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }

  checkURL: boolean;
  userSessions: any = [];
  currentUser: any;
  shortName: string;
  currentLang: string;

  @Input() ClassGet;
  hideHeader: boolean = false;
  car: any;
  customLoader: boolean;
  page: number = 1;
  itemPerPage: number = 10;
  todayAuctionsList: any[] = [];
  auctionList: any = [];
  totalCount: number;
  notFound: boolean;
  showAuctionJoinMessage: boolean = true;

  constructor(
    private router: Router,
    private authService: AuthService,
    private signUpService: SingUpService,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private toastService: ToastrService,
    private datePipe: DatePipe,
    private spinner: SpinnerVisibilityService,
    private service: SallerBuyerService,
    private languageService: LanguageService,
    private translate: TranslateService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRouteToHideMessage();
      }
    });
  }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    this.shortName = this.currentUser?.name?.slice(0, 2).toUpperCase();
    this.currentLang = this.languageService.getCurrentLang() || 'eng';
    this.checkRouteToHideMessage();
  }

  ngAfterViewInit() {
    this.getAuctionList(this.page, this.itemPerPage);
    this.auctionJoinHide();
    this.hideHeader = true;
  }

  ngOnDestroy(): void {
    // no-op
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!this.auctionsMenu?.nativeElement?.contains(target)) {
      this.showSubmenu = false;
      this.showLaneSubmenu = false;
    }
  }
  onDropdownOpen(): void {
    this.getAnalytics(); // Your existing API call
  }

  analyticdata: any = {};
  getAnalytics() {
    let data = {
      userId: this.currentUser._id,
    };
    this.service.getBuyerAnalytics(data).subscribe((res: any) => {
      if (res.status == true) {
        this.analyticdata = res.result;
      }
    });
  }

  changeLanguage() {
    const newLang = this.currentLang === 'eng' ? 'ara' : 'eng';
    this.currentLang = newLang;
    this.languageService.setLanguage(newLang);
  }

  /**
   * Helper method to get language-aware route
   */
  getLangRoute(route: string): string {
    return this.languageService.getLanguageAwareUrl(route);
  }

  auctionJoin(data: any, lane: string = 'unassigned') {


    if (!this.currentUser) {

      this.toastService.info(this.translate.instant('auctions.message1'), this.translate.instant('tooltips.warning'));
      return
    }
    // if (this.currentUser?.status != 1) {
    //   this.toastService.info(this.translate.instant('auctions.message2'), this.translate.instant('tooltips.info'));
    //   return
    // }
    if (this.currentUser) {
      if (this.currentUser.userType === 4 || this.currentUser.userType === 5)
        // this.route.navigateByUrl(['auction-join', {id:data?._id,auction:true}]);
        this.router.navigateByUrl(`auction-join?id=${data?._id}${lane != 'unassigned' ? '&&lane=' + lane : ''}`);
      else
        this.toastService.warning(this.translate.instant('auctions.message1'), this.translate.instant('tooltips.warning'));
    } else {
      this.toastService.warning(this.translate.instant('auctions.message1'), this.translate.instant('tooltips.warning'))
    }
  }

  private checkRouteToHideMessage(): void {
    const currentRoute = this.router.url;
    const routesToHide = ['job-listing', 'job-Description', 'job-Apply'];

    // Check if current route contains any of the routes to hide
    this.showAuctionJoinMessage = !routesToHide.some(route =>
      currentRoute.includes(route)
    );
  }

  checkTimeOver(end: any) {
    let hour: any = end.split("T")[1].split(":")[0];
    let min: any = end.split("T")[1].split(":")[1];
    let formatedTime = this.datePipe.transform(end, 'yyyy-MM-dd HH:mm', 'UTC');
    let time = new Date(formatedTime);
    // time.setHours(parseInt(hour));
    // time.setMinutes(parseInt(min));
    const timeDiff = time.getTime() - new Date().getTime();
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
    if (seconds < 0) {
      return true
    }
  }

  compareDate(startDate: any, id: any) {
    let auctionStartDataTime = new Date(startDate).getTime();
    let currentDate = new Date().getTime();
    //capare Date and Time
    if (currentDate > auctionStartDataTime) {
      const auctionUrl = this.languageService.getLanguageAwareUrl('auction-join?id=' + id);
      this.router.navigateByUrl(auctionUrl);
    } else {
      this.toastService.error(this.translate.instant('auctions.message3'));
    }
  }

  getAuctionList(page: any, pageLimit: any) {
    // this.spinner.show();
    this.customLoader = true;
    let data = {
      pageLimit: pageLimit,
      page: page,
      inventoryStatus: 2,
      pendingcar: true,
      isAuctionActive: true,
      orderBy: 'auctionDate',
      fromData: this.datePipe.transform(new Date().setDate(new Date().getDate() - 1), 'yyyy-MM-dd'),
      toData: this.datePipe.transform(
        new Date().setDate(new Date().getDate() + 2),
        'yyyy-MM-dd'
      ),
    };


    this.service.auctionListwithDate(data).subscribe((res: any) => {
      if (res.status == true) {

        let data = res.result;
        this.cdr.detectChanges();
        data.forEach(element => {
          let value = this.isToday(element.auctionDate);
          value === true ? this.todayAuctionsList.push(element) : this.auctionList.push(element);
        });
      }
      this.customLoader = false;
    });
    // this.spinner.hide();
  }

  isAuctionJoinShow = false;
  auctionJoinHide() {
    this.sharedService.isShowheader$.subscribe((val: any) => {
      if (val === true) {
        this.isAuctionJoinShow = val;
      } else {
        this.isAuctionJoinShow = false;
      }
    })
  }

  toggleSubmenu(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showSubmenu = !this.showSubmenu;
  }

  toggleLaneSubmenu(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showLaneSubmenu = !this.showLaneSubmenu;
  }

  get todayAuctionLanes(): any[] {
    const lanes = this.todayAuctionsList?.[0]?.lanes || [];
    return lanes.filter((lane: any) => lane?.lane && lane.lane !== 'unassigned');
  }

  get hasMultipleLanes(): boolean {
    return (this.todayAuctionsList?.[0]?.lanes || []).length > 1;
  }

  isToday(dateString: string): boolean {
    const today = new Date();
    const date = new Date(this.datePipe.transform(dateString, 'yyyy-MM-dd', 'UTC'));
    let returnValue = false;
    if (date.getDate() <= today.getDate() &&
      date.getMonth() <= today.getMonth() &&
      date.getFullYear() <= today.getFullYear()) {
      returnValue = true
    }
    else {
      returnValue = false;
    }
    return returnValue;
  }

  HeaderStyle1() {
    this.hideHeader = false;
    setTimeout(() => {
      this.hideHeader = true;
    }, 3000)
    this.sharedService.hideFooterElement(true);
    this.checkURL = true;
  }
  HeaderStyle2() {
    // this.sharedService.hideFooterElement(true);
    this.checkURL = false;
  }

  logout() {
    this.hideHeader = false;

    setTimeout(() => {
      this.hideHeader = true;
    }, 3000)
    this.sharedService.hideFooterElement(true);

    this.authService.logout();
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem("sortTypeKey");
    localStorage.removeItem("sortTypeOrder");
    localStorage.removeItem("isViewTypeList");

    // Navigate to home with language-aware URL
    const homeUrl = this.currentLang === 'ara' ? '/ar/home' : '/home';
    this.router.navigateByUrl(homeUrl);
    this.currentUser = null;
    //location.reload();
    // this.cdr.detectChanges();
  }

  activateSignUpPopUp(isEnable) {
    this.signUpService.EnableSignUpModel(isEnable)
  }


  lowercaseTitle(title) {
    title = title.toLowerCase();
    return title;
  }
  openNav() {
    document.getElementById("mySidenav").style.width = "44%";
  }
  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }
}
